import { StatusKind } from '../enums';

/**
 * Resolves the column the performance table should rank by for the selected
 * KPI (status kind). Matches the KPI column ids produced by
 * getPerformanceTableColumns so rows arrive pre-sorted highest -> lowest.
 * Falls back to 'name' when no KPI is selected.
 */
export default function getPerformanceOrderingField(
  statusKind?: StatusKind,
): string {
  switch (statusKind) {
    case StatusKind.WarningAndAlert:
    case StatusKind.Warning:
    case StatusKind.Alert:
      return 'totalAnomaliesByTaskResults';
    case StatusKind.DeadlineMissed:
      return 'totalAnomaliesByTaskDeadlinesMissed';
    default:
      return 'name';
  }
}
